import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import ItemSimple from "../Shared/ItemSimple"
import Totals from "./Totals"
import CaseSummarySidebar from "./CaseSummarySidebar"
import CaseSummaryBox from "./CaseSummaryBox"
import { formatCurrency, totalItemsValue } from "../../../../lib/script"

import SimpleBoxDisplay from "../../../common/SimpleBoxDisplay"



import classes from '../Shared/Item.module.css'
import LiabilitySummary from "./sections/LiabilitySummary"
import { searchTabInCaseType } from "../../../../lib/misc"
import MedPaySummary from "./sections/MedPaySummary"
import WorkersCompSummary from "./sections/WorkersCompSummary"
import UmSummary from "./sections/UmSummary"
import MajorMedicalSummary from "./sections/MajorMedicalSummary"
import CrimeVictimSummary from "./sections/CrimeVictimSummary"
import PreviousCareSection from "./sections/PreviousCareSection"
import PoliceReportSection from "./sections/PoliceReportSection"

const CaseSummaryItem = ({itemData, apiCase, permissionType}) => {
    const activeCase = useSelector(state => state.case.activeCase)

    const [primaryLiability, setPrimaryLiability] = useState(null)
    const [primaryMpPipUm, setPrimaryMpPipUm] = useState(null)
    const [primaryUm, setPrimaryUm] = useState(null)
    const [primaryMajorMeds, setPrimaryMajorMeds] = useState(null)
    const [primaryWorkerComp, setPrimaryWorkerComp] = useState(null)
    const [primaryCrimeVictim, setPrimaryCrimeVictim] = useState(null)

    useEffect(() => {
        if (activeCase) {
            if (activeCase.liabilities) {
                let primaryInsurance = activeCase.liabilities.find(item => item.is_primary_insurance)
                if (primaryInsurance) {
                    setPrimaryLiability(primaryInsurance)                
                } else {
                    setPrimaryLiability(null)
                }
            }

            if (activeCase.mp_pip_um) {
                let primaryInsurance = activeCase.mp_pip_um.find(item => item.is_primary_insurance)
                if (primaryInsurance) {
                    setPrimaryMpPipUm(primaryInsurance)                
                } else {
                    setPrimaryMpPipUm(null)
                }
            }

            if (activeCase.mp_pip_um) {
                let primaryInsurance = activeCase.mp_pip_um.find(item => item.is_um_primary_insurance)
                if (primaryInsurance) {
                    setPrimaryUm(primaryInsurance)                
                } else {
                    setPrimaryUm(null)
                }
            }
            if (activeCase.major_meds) {
                let primaryInsurance = activeCase.major_meds.find(item => item.is_primary_insurance)
                if (primaryInsurance) {
                    setPrimaryMajorMeds(primaryInsurance)                
                } else {
                    setPrimaryMajorMeds(null)
                }
            }

            if (activeCase.worker_comp) { 
                setPrimaryWorkerComp(activeCase.worker_comp)
            }

            if (activeCase.crime_victim) { 
                setPrimaryCrimeVictim(activeCase.crime_victim)
            }
  
        }

    }, [activeCase])

    return <ItemSimple>
        <div className={classes.item_inner}>
            <div className={classes.item_left}>
                <div className={classes.row}>
                    <Totals practices={itemData.practices} label={'Total Charges'} identifier={'total_charges'}/>
                    <Totals practices={itemData.practices} label={'Total Practice Balances'} identifier={'balance'}/>
                </div>

                {/* ##### not editable ####  */}
                <div className={classes.row}>
                    {searchTabInCaseType(activeCase, "liability") && <LiabilitySummary primaryLiability={primaryLiability} classes={classes}/>}

                    {searchTabInCaseType(activeCase, "medpay_pip") && <MedPaySummary primaryMpPipUm={primaryMpPipUm} classes={classes} activeCase={activeCase}/>}
   
                    {searchTabInCaseType(activeCase, "workers_comp") && <WorkersCompSummary primaryWorkerComp={primaryWorkerComp} classes={classes}/>}
                </div>


                <div className={`${classes.row} ${classes.summary_boxes_row}`}>
                    {searchTabInCaseType(activeCase, "um") && <UmSummary primaryMpPipUm={primaryUm} classes={classes} activeCase={activeCase}/>}

                    {searchTabInCaseType(activeCase, "major_med") && <MajorMedicalSummary primaryMajorMeds={primaryMajorMeds} classes={classes}/>}  

                    {searchTabInCaseType(activeCase, "negotiation") && <CaseSummaryBox title={'Negotiation'} tabNumber={16} >
                        <div className={classes.row}>
                            <SimpleBoxDisplay label={'Total Outside Liens'} value={`$${formatCurrency(totalItemsValue(activeCase.case_outside_liens, 'amount'))}`}/>
                        </div>
                    </CaseSummaryBox>} 
           
                    {searchTabInCaseType(activeCase, "crime_victim") && <CrimeVictimSummary primaryCrimeVictim={primaryCrimeVictim} classes={classes}/>}                     
                </div>   
                {/* ##### not editable ####  */}

                <div className={classes.row}>
                    <PreviousCareSection apiCase={apiCase} permissionType={permissionType}/>     
                </div>      
                <div className={classes.row}>
                    <PoliceReportSection apiCase={apiCase} permissionType={permissionType}/>     
                </div>   
            </div>
            <div className={classes.item_right}>
                <CaseSummarySidebar itemData={itemData} apiCase={apiCase} permissionType={permissionType}/>
            </div>
        </div>
    </ItemSimple>
}

export default CaseSummaryItem